<template>
  <ChecklistActivityListEmbeddable :activity-number="5" />
</template>
<script>
import ChecklistActivityListEmbeddable from "@/views/modules/checklist/ChecklistActivity/embeddable/ChecklistActivityListEmbeddable";

export default {
  components: {ChecklistActivityListEmbeddable},
  name: 'ChecklistActivity1',
}
</script>

